import type { GIFT_CARD_FIELDS } from '../types';
import { GIFT_CARD_TYPE } from './giftcard';
import { giftCardAmount } from './validators';

export type InitialValues = Record<GIFT_CARD_TYPE, Partial<Record<GIFT_CARD_FIELDS, string>>>;
export type ValidationSchemas = Record<GIFT_CARD_TYPE, Record<GIFT_CARD_FIELDS, string | ((value?: string | null) => string | boolean)>>;

export const INITIAL_VALUES: InitialValues = {
  [GIFT_CARD_TYPE.BASIC]: {
    giftCardAmount: '',
    giftCardMessage: '',
    giftCardFromName: '',
    giftCardToName: '',
  },
  [GIFT_CARD_TYPE.E_GIFT_CARD]: {
    giftCardAmount: '',
    giftCardEmailId: '',
    giftCardMessage: '',
    giftCardFromName: '',
    giftCardToName: '',
  },
  [GIFT_CARD_TYPE.CONSOLIDATED_MASTER]: {
    giftCardAmount: '',
  },
};

export const VALIDATION_SCHEMAS: ValidationSchemas = {
  [GIFT_CARD_TYPE.BASIC]: {
    giftCardAmount: 'giftPrice',
    giftCardEmailId: '',
    giftCardMessage: 'giftMessage',
    giftCardFromName: 'giftToFrom',
    giftCardToName: 'giftToFrom',
  },
  [GIFT_CARD_TYPE.E_GIFT_CARD]: {
    giftCardAmount: 'giftPrice',
    giftCardEmailId: 'email',
    giftCardMessage: 'giftMessage',
    giftCardFromName: 'giftToFrom',
    giftCardToName: 'giftToFrom',
  },
  [GIFT_CARD_TYPE.CONSOLIDATED_MASTER]: {
    giftCardAmount,
    giftCardEmailId: '',
    giftCardMessage: '',
    giftCardFromName: '',
    giftCardToName: '',
  },
};
